import { FormInstance } from 'antd';
import { DependencyList, useEffect } from 'react';

export const useUpdateFormEffect = <T>(
  form: FormInstance<T>,
  data: Parameters<FormInstance<T>['setFieldsValue']>[0],
  deps: DependencyList
) => useEffect(() => form.setFieldsValue(data), deps);
